import { Injectable, signal } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class ContractControlHelperService {
    
    public refreshContracts = signal(false)
    

    /**
     * Sends a signal to fetch contracts by setting the `refreshContracts` observable to true.
     */
    refreshContractList() {
        this.refreshContracts.set(true);
    }


    /**
     * Resets the signals by setting the refreshContracts observable to false.
     */
    resetSignals(){
        this.refreshContracts.set(false);
    }
}